import styled from '@emotion/styled';
import { Modal as AntdModal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import React from 'react';
import { useTranslation } from 'react-i18next';

import closeIcon from 'src/public/img/close-icon.svg';

import { color } from '../styles/variables';

const ExitIcon = styled.div({
    height: 32,
    width: 32,
    border: `2px solid ${color.catskillWhite}`,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px 10px 0 auto',
    backgroundColor: color.white,
    img: {
        width: 8,
    },
});

interface Props extends ModalProps {
    closeButtonTestID?: string;
}

export const Modal: React.FC<Props> = props => {
    const { t } = useTranslation();

    const handleAfterClose = () => {
        document.body.style.overflow = 'auto';

        if (props.afterClose) {
            props.afterClose();
        }
    };

    return (
        <AntdModal
            {...props}
            afterClose={handleAfterClose}
            closeIcon={
                <ExitIcon data-testid={props.closeButtonTestID || ''} className="exitIcon">
                    <img src={closeIcon} alt={t('common.close')} />
                </ExitIcon>
            }
        >
            {props.children}
        </AntdModal>
    );
};
